<template>
  <div class="tx-list-page">
    <v-container fluid grid-list-xl>
      <v-layout row wrap>
        <v-flex xs12>
          <div class="list-hero">
            <p class="list-crumb">Contabilidad / Facturación por Servicios</p>
            <h1 class="list-title">Facturación por Servicios</h1>
            <p class="list-subtitle">
              Trámites aprobados con su impuesto ya pagado, listos para emitir
              la factura de servicios al cliente.
            </p>
          </div>
        </v-flex>

        <v-flex xs12>
          <tx-filter @search="onSearch" @download="onDownload"></tx-filter>
        </v-flex>

        <v-flex xs12>
          <v-card class="tx-card">
            <div class="tx-toolbar">
              <div class="tx-toolbar__info">
                <span class="tx-chip">
                  <v-icon small class="tx-chip__icon">receipt_long</v-icon>
                  {{ meta.totalGroups }} trámites
                  <template v-if="meta.totalInvoices !== meta.totalGroups">
                    ({{ meta.totalInvoices }} facturas)
                  </template>
                </span>
                <v-tooltip bottom>
                  <template slot="activator">
                    <span class="tx-chip tx-chip--danger">
                      <span class="light light--red light--chip"></span>
                      {{ pendientes }} sin facturar
                    </span>
                  </template>
                  <span
                    >Trámites de esta búsqueda que aún no tienen factura</span
                  >
                </v-tooltip>
                <v-tooltip bottom>
                  <template slot="activator">
                    <span class="tx-chip tx-chip--ok">
                      <span class="light light--green light--chip"></span>
                      {{ facturados }} facturados
                    </span>
                  </template>
                  <span
                    >Trámites de esta búsqueda con su factura ya emitida</span
                  >
                </v-tooltip>
                <span v-if="totalPagina" class="tx-chip tx-chip--warn">
                  <v-icon small class="tx-chip__icon">payments</v-icon>
                  B/. {{ money(totalPagina) }} facturado en esta página
                </span>
              </div>
            </div>
            <v-divider></v-divider>

            <v-card-text class="pa-0">
              <div class="table-wrap">
                <table class="tx-table">
                  <thead>
                    <tr>
                      <th class="th-center">Estado</th>
                      <th># Factura</th>
                      <th class="th-right">Monto CIF (USD)</th>
                      <th>Laboratorio</th>
                      <th>Distribuidor</th>
                      <th>Órganos Anuentes</th>
                      <th>Fecha de Aprobación</th>
                      <th class="th-right">Monto de Impuestos</th>
                      <th>Fecha pago impuestos</th>
                      <th class="th-right">Total Reembolso</th>
                      <th class="th-right">Facturación por Servicios</th>
                      <th>Fecha de Facturación</th>
                      <th class="th-actions">Detalle</th>
                    </tr>
                  </thead>
                  <!-- Un <tbody> por trámite: la banda con el consecutivo y,
                       debajo, una fila por factura. Es el mismo patrón de
                       filas agrupadas de todas las listas de Transit
                       (tx-group-row), con el texto de la banda del mixin
                       TramiteBand; el grupo entero abre el diálogo. -->
                  <tbody
                    v-for="g in groups"
                    :key="g.key"
                    class="tx-group"
                    @click="openBilling(g.tramite)"
                  >
                    <tr
                      class="tx-group-row"
                      :class="{ 'tx-group-row--single': !esConsolidado(g) }"
                    >
                      <td colspan="13">
                        <v-icon small class="tx-group-row__icon">
                          {{ esConsolidado(g) ? 'layers' : 'description' }}
                        </v-icon>
                        {{ etiquetaTramite(g) }}
                        <strong>{{ consecutivoDe(g) }}</strong>
                        &middot; {{ facturasDe(g) }}
                        <span
                          v-if="esConsolidado(g)"
                          class="tx-group-row__muted"
                        >
                          &middot; CIF total {{ money(cifTramiteDe(g)) }}
                        </span>
                        <span v-if="controlFdDe(g)" class="tx-group-row__muted">
                          &middot; Control F&amp;D: {{ controlFdDe(g) }}
                        </span>
                      </td>
                    </tr>

                    <!-- Una fila por factura. Lo que es del TRÁMITE (semáforo,
                         órganos, fechas, montos, reembolso, facturación y
                         detalle) va una sola vez, en la primera fila, y abarca
                         las demás con rowspan: así nada se repite. -->
                    <tr
                      v-for="(inv, i) in g.invoices"
                      :key="inv.id"
                      :class="{ 'tx-child-row': esConsolidado(g) }"
                    >
                      <!-- Semáforo: rojo mientras no se haya facturado -->
                      <td
                        v-if="i === 0"
                        :rowspan="g.invoices.length"
                        class="th-center"
                      >
                        <v-tooltip bottom>
                          <template slot="activator">
                            <span
                              class="light"
                              :class="
                                g.tramite.serviceInvoiceDate
                                  ? 'light--green'
                                  : 'light--red'
                              "
                            ></span>
                          </template>
                          <span>
                            {{
                              g.tramite.serviceInvoiceDate
                                ? 'Realizado: la facturación por servicios ya fue emitida'
                                : 'Pendiente: falta la facturación por servicios'
                            }}
                          </span>
                        </v-tooltip>
                      </td>
                      <td class="tx-cell--strong tx-cell--factura">
                        {{ inv.invoiceNumber || '—' }}
                      </td>
                      <td class="th-right tx-nowrap">{{ money(inv.cif) }}</td>
                      <td>{{ inv.laboratorio || '—' }}</td>
                      <td>{{ inv.distribuidor || '—' }}</td>
                      <td v-if="i === 0" :rowspan="g.invoices.length">
                        <div
                          v-if="
                            g.tramite.organosAnuentes &&
                              g.tramite.organosAnuentes.length
                          "
                          class="organo-list"
                        >
                          <span
                            v-for="o in g.tramite.organosAnuentes"
                            :key="o.id"
                            class="organo-tag"
                          >
                            {{ o.name }}
                          </span>
                        </div>
                        <span v-else class="tx-muted">—</span>
                      </td>
                      <td
                        v-if="i === 0"
                        :rowspan="g.invoices.length"
                        class="tx-nowrap"
                      >
                        {{ dateOf(g.tramite.departureDate) }}
                      </td>
                      <td
                        v-if="i === 0"
                        :rowspan="g.invoices.length"
                        class="th-right tx-nowrap"
                      >
                        <span v-if="g.tramite.taxAmount">{{
                          money(g.tramite.taxAmount)
                        }}</span>
                        <span v-else class="tx-muted">—</span>
                      </td>
                      <td
                        v-if="i === 0"
                        :rowspan="g.invoices.length"
                        class="tx-nowrap"
                      >
                        {{ dateOf(g.tramite.taxPaidDate) }}
                      </td>
                      <!-- Gasto total de reembolso del trámite: la misma suma
                           que muestra Facturación de Reembolso. -->
                      <td
                        v-if="i === 0"
                        :rowspan="g.invoices.length"
                        class="th-right tx-nowrap"
                      >
                        <strong v-if="reembolso(g.tramite).total">
                          {{ money(reembolso(g.tramite).total) }}
                        </strong>
                        <span v-else class="tx-muted">—</span>
                      </td>
                      <!-- Un solo monto: el total de la factura de servicios
                           (líneas + I.T.B.M.S. − retención). Formularios, líneas
                           y corretaje se ven y se llenan en el Detalle; el
                           cliente no quiere esa información en la tabla. -->
                      <td
                        v-if="i === 0"
                        :rowspan="g.invoices.length"
                        class="th-right tx-nowrap"
                      >
                        <strong v-if="resumen(g.tramite).total">
                          {{ money(resumen(g.tramite).total) }}
                        </strong>
                        <span
                          v-else
                          class="tx-muted"
                          title="Genera las líneas desde el Detalle"
                        >
                          Sin líneas
                        </span>
                      </td>
                      <!-- La factura de servicios de Alegra: su N° (manual,
                           se escribe en el Detalle) y su fecha. El estado de
                           cuenta la lista así y sin el N° no se puede emitir:
                           por eso se avisa aquí cuando falta. -->
                      <td
                        v-if="i === 0"
                        :rowspan="g.invoices.length"
                        class="tx-nowrap"
                      >
                        <template v-if="g.tramite.serviceInvoiceDate">
                          <div
                            v-if="g.tramite.serviceInvoiceNumber"
                            class="tx-cell--strong"
                          >
                            {{ g.tramite.serviceInvoiceNumber }}
                          </div>
                          <div
                            v-else
                            class="tx-warn"
                            title="Escribe el N° de la factura de Alegra en el Detalle"
                          >
                            Falta N° Alegra
                          </div>
                          <div>{{ dateOf(g.tramite.serviceInvoiceDate) }}</div>
                        </template>
                        <span
                          v-else
                          class="tx-muted"
                          title="Se fija sola al cargar el comprobante"
                        >
                          Al cargar comprobante
                        </span>
                      </td>
                      <td
                        v-if="i === 0"
                        :rowspan="g.invoices.length"
                        class="th-actions"
                        @click.stop
                      >
                        <v-tooltip bottom>
                          <template slot="activator">
                            <button
                              class="doc-btn"
                              :class="{
                                'doc-btn--done': !!g.tramite.serviceInvoiceDate,
                              }"
                              @click="openBilling(g.tramite)"
                            >
                              <v-icon small>receipt_long</v-icon>
                              Detalle
                            </button>
                          </template>
                          <span>
                            Líneas facturables, totales con I.T.B.M.S. y
                            comprobantes
                          </span>
                        </v-tooltip>
                      </td>
                    </tr>
                  </tbody>

                  <tbody v-if="!pagination.loading && groups.length === 0">
                    <tr>
                      <td colspan="13" class="empty-state">
                        No hay trámites con los filtros aplicados.
                      </td>
                    </tr>
                  </tbody>
                  <tbody v-if="pagination.loading">
                    <tr>
                      <td colspan="13" class="empty-state">Cargando...</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </v-card-text>
          </v-card>
        </v-flex>

        <v-flex xs12 v-if="pagination.pages">
          <div class="list-footer">
            <div class="list-footer__count">
              Mostrando {{ groups.length }} de {{ meta.totalGroups }} trámites
              ({{ meta.totalInvoices }} facturas)
            </div>
            <v-pagination
              v-model="pagination.page"
              :length="pagination.pages"
              :total-visible="7"
              color="#254f87"
              @input="asyncPagination"
            ></v-pagination>
          </div>
        </v-flex>
      </v-layout>
    </v-container>

    <v-dialog max-width="860" v-if="billing.data" v-model="billing.show">
      <service-billing-dialog
        :key="billing.key"
        :item="billing.data"
        v-on:close-billing="billing.show = false"
        v-on:changed="onChanged"
      ></service-billing-dialog>
    </v-dialog>

    <v-dialog max-width="350" persistent v-model="loading">
      <loading></loading>
    </v-dialog>

    <v-snackbar
      v-model="snack.show"
      :timeout="4000"
      :color="snack.color"
      right
      top
    >
      {{ snack.message }}
      <v-btn flat dark @click="snack.show = false">Cerrar</v-btn>
    </v-snackbar>
  </div>
</template>

<script>
import moment from 'moment'
import loading from './../dialog/DialogLoading'
import serviceBillingDialog from './../dialog/DialogServiceBilling'
import TxFilter from './../transit/TransitFilter.vue'
import TramiteBand from './../transit/mixins/TramiteBand'
import SessionHelper from '@/helpers/SessionHelper'

export default {
  components: {
    loading,
    'service-billing-dialog': serviceBillingDialog,
    'tx-filter': TxFilter,
  },
  // Banda del trámite y money(): la misma fuente que Facturas y Transit.
  mixins: [TramiteBand],
  data() {
    return {
      loading: true,
      groups: [],
      meta: { totalGroups: 0, totalInvoices: 0, totalDone: 0 },
      pagination: {
        page: 1,
        rpp: this.$config.resultsPerPage,
        totalItems: 0,
        loading: true,
        pages: 0,
        search: {},
      },
      billing: { show: null, data: null, key: 0 },
      // Totales por factura para la columna de facturación. Se piden en una
      // sola consulta para toda la página, no una por fila.
      summaries: {},
      // Gasto total de reembolso por trámite (columna Total Reembolso). Igual
      // que los servicios: una sola consulta para toda la página, en paralelo.
      reimbursements: {},
      snack: { show: false, color: 'info', message: '' },
    }
  },
  created() {
    this.asyncPagination()
  },
  computed: {
    // Una fila por TRÁMITE: la fila padre del consolidado (con el CIF sumado)
    // o la factura sola. Es lo que contabilidad cobra.
    tramites() {
      return this.groups.map(g => g.tramite).filter(Boolean)
    },
    invoices() {
      return this.tramites
    },
    pageIds() {
      return this.invoices.map(item => item.id)
    },
    // Contadores de TODO el filtro, no de la página: la API los cuenta sobre
    // el listado completo. Antes se contaban las filas cargadas y el chip
    // daba una idea falsa de cuánto falta por facturar.
    facturados() {
      return this.meta.totalDone
    },
    pendientes() {
      return Math.max(0, this.meta.totalGroups - this.meta.totalDone)
    },
    // Solo lo ya facturado: un trámite con líneas pero sin comprobante aún
    // no se le ha cobrado al cliente.
    totalPagina() {
      return this.invoices
        .filter(i => i.serviceInvoiceDate)
        .reduce((acc, i) => acc + this.resumen(i).total, 0)
    },
  },
  methods: {
    dateOf(value) {
      return value ? moment(value).format('DD/MM/YYYY') : '—'
    },
    // El total sale SOLO de las líneas del trámite. La columna
    // customsServiceAmount de la factura ya no se usa aquí: era una segunda
    // fuente del corretaje y divergía de la línea (1,390.05 vs 1,352.60).
    resumen(item) {
      return this.summaries[item.id] || { total: 0 }
    },
    reembolso(item) {
      return this.reimbursements[item.id] || { count: 0, total: 0 }
    },
    notify(message, color = 'info') {
      this.snack = { show: true, color, message }
    },
    helperPaginate(response) {
      this.groups = (response && response.groups) || []
      this.meta = {
        totalGroups: (response && response.totalGroups) || 0,
        totalInvoices: (response && response.totalInvoices) || 0,
        totalDone: (response && response.totalDone) || 0,
      }
      this.pagination.totalItems = this.meta.totalInvoices
      this.pagination.pages =
        Math.ceil(this.meta.totalGroups / this.pagination.rpp) || 0
      this.loading = false
      this.pagination.loading = false
      // Las dos consultas de la página salen a la vez: ninguna depende de
      // la otra.
      this.loadSummaries()
      this.loadReimbursements()
    },
    loadSummaries() {
      if (!this.pageIds.length) {
        this.summaries = {}
        return
      }
      this.$store
        .dispatch('invoices/getServiceItems', { ids: this.pageIds.join(',') })
        .then(rows => {
          const acc = {}
          ;(rows || []).forEach(r => {
            acc[r.invoiceId] = r.totals || { total: 0 }
          })
          this.summaries = acc
        })
    },
    // Gasto total de reembolso por trámite, con la MISMA suma que hace
    // Facturación de Reembolso para que las dos pantallas digan lo mismo.
    loadReimbursements() {
      if (!this.pageIds.length) {
        this.reimbursements = {}
        return
      }
      this.$store
        .dispatch('invoices/getReimbursements', {
          ids: this.pageIds.join(','),
        })
        .then(lines => {
          const acc = {}
          ;(lines || []).forEach(l => {
            // Solo cuenta lo que tiene monto: la línea del impuesto se refleja
            // sola desde Pago de Impuestos y, vacía, no es un adelanto.
            const amount =
              l.amount === null || typeof l.amount === 'undefined'
                ? NaN
                : parseFloat(l.amount)
            if (Number.isNaN(amount)) return
            if (!acc[l.invoiceId]) acc[l.invoiceId] = { count: 0, total: 0 }
            acc[l.invoiceId].count += 1
            acc[l.invoiceId].total += amount
          })
          this.reimbursements = acc
        })
    },
    // Cualquier cambio en el detalle (líneas, cantidades, comprobante subido
    // o borrado) puede mover el total, el semáforo o la fecha: se recarga la
    // página para que la fila diga lo mismo que el diálogo.
    onChanged() {
      this.asyncPagination()
    },
    asyncPagination() {
      this.pagination.loading = true
      const filter = {
        rpp: this.pagination.rpp,
        page: this.pagination.page,
        status: 'billing',
        ...this.pagination.search,
      }
      return new Promise(resolve => {
        this.$store
          .dispatch('invoices/getConsolidated', filter)
          .then(response => {
            this.helperPaginate(response)
            return resolve()
          })
      })
    },
    openBilling(item) {
      this.billing = {
        data: item,
        show: true,
        key: this.billing.key + 1,
      }
    },
    onSearch(params) {
      Object.keys(params).forEach(key => {
        if (params[key] == null || params[key] === '') delete params[key]
      })
      this.pagination.search = params
      this.pagination.page = 1
      this.asyncPagination()
    },
    onDownload() {
      const filter = {
        status: 'billing',
        ...this.pagination.search,
        token: SessionHelper.token,
      }
      this.$socket.emit('exportTransitInvoices', filter)
    },
  },
}
</script>

<style scoped src="./../transit/transit-list.css"></style>

<style scoped>
/* El grupo entero (banda + facturas) abre el diálogo del trámite. El realce
   conjunto del grupo viene de transit-list.css. */
.tx-group {
  cursor: pointer;
}

/* Aviso discreto: hay factura adjunta pero falta su N° de Alegra. */
.tx-warn {
  font-size: 12.5px;
  font-weight: 600;
  color: #b91c1c;
}
.light {
  display: inline-block;
  width: 12px;
  height: 12px;
  border-radius: 50%;
  vertical-align: middle;
}
.light--red {
  background: #dc2626;
  box-shadow: 0 0 0 3px rgba(220, 38, 38, 0.18);
}
.light--green {
  background: #15803d;
  box-shadow: 0 0 0 3px rgba(21, 128, 61, 0.18);
}
/* Dentro de un chip el halo no cabe: se queda sólo el punto. */
.light--chip {
  width: 9px;
  height: 9px;
  box-shadow: none;
  margin-right: 6px;
}

.tx-chip--danger {
  background: rgba(220, 38, 38, 0.12);
  color: #991b1b;
}
.tx-chip--ok {
  background: rgba(21, 128, 61, 0.12);
  color: #14532d;
}
.tx-chip--warn {
  background: #fffbeb;
  color: #92400e;
}
.tx-chip--warn .tx-chip__icon {
  color: #b45309 !important;
}

.doc-btn {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  height: 28px;
  padding: 0 10px;
  border-radius: 6px;
  border: 1px solid #cbd5e1;
  background: #ffffff;
  color: #475569;
  font-size: 12px;
  font-weight: 600;
  white-space: nowrap;
  cursor: pointer;
  transition: all 0.18s ease;
}
.doc-btn .v-icon {
  color: #64748b !important;
  font-size: 15px !important;
}
.doc-btn:hover {
  background: #f1f5f9;
  border-color: #94a3b8;
}
.doc-btn--done {
  border-color: #bbf7d0;
  background: #f0fdf4;
  color: #14532d;
}
.doc-btn--done .v-icon {
  color: #15803d !important;
}
/* En Transit la sangría del consolidado va en la primera celda, que es la
   factura; aquí la primera es el semáforo y abarca todo el grupo, así que
   la sangría pasa a la celda de la factura. La regla de la factura se repite
   aunque ya esté en transit-list.css porque debe ir DESPUÉS de anular la
   primera celda: desde la segunda fila el semáforo (rowspan) no está y la
   factura es la primera celda. */
.tx-child-row td:first-child {
  padding-left: 14px;
  border-left: 0;
}
.tx-child-row td.tx-cell--factura {
  padding-left: 22px;
  border-left: 3px solid #cbd5e1;
}
</style>
